export function assertExhaustive(value) {
    throw new Error(`Unhandled discriminated-union variant: ${JSON.stringify(value)}`);
}
